import { render, staticRenderFns } from "./createRate.vue?vue&type=template&id=1094a424&scoped=true&"
import script from "./createRate.vue?vue&type=script&lang=js&"
export * from "./createRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094a424",
  null
  
)

export default component.exports